import { render, staticRenderFns } from "./ArticleExam.vue?vue&type=template&id=6e7369ae&scoped=true&"
import script from "./ArticleExam.vue?vue&type=script&lang=js&"
export * from "./ArticleExam.vue?vue&type=script&lang=js&"
import style0 from "./ArticleExam.vue?vue&type=style&index=0&id=6e7369ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7369ae",
  null
  
)

component.options.__file = "ArticleExam.vue"
export default component.exports